import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc56983c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-list-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-list-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "顧客詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "warning" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "red-required" }, "顧客の紐付けができていないユーザーです")
  ])
], -1))
const _hoisted_3 = { class: "search-account" }
const _hoisted_4 = { class: "flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "flex justify-content-start w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-lms_search show-search-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid grid-nogutter grid-header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, "カルテNo."),
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, "名前")
  ])
], -1))

import { ref, onBeforeMount, inject, computed } from "vue";
import { CustomerServices } from "@/clinic/services";
import { ApiCustomerIndexRes, ICustomer } from "@/clinic/typings";
import { AnyFn, Fn, get, set, useScroll, toRefs, useArrayFindIndex } from "@vueuse/core";
import { AxiosResponse } from "axios";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { CUSTOMER_FIRST_PAGINATOR_ROWS } from "@/clinic/typings/constants/direct-message";
import { BasicCustomerFilterFields, CustomerFilterLineBy } from "@/clinic/typings/enums/customer";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const customers = ref<ICustomer[]>([]);
const term = ref<string>("");
const clinicId = ref(0);

const scrollCustomer = ref<HTMLElement>();
const smooth = ref(false);
const behavior = computed(() => (smooth.value ? "smooth" : "auto"));
const loadedMore = ref(true);

const disableLoadMore = () => set(loadedMore, false);

const onScroll = () => {
  if (get(bottom) && get(loadedMore)) loadCustomers();
};
const { arrivedState } = useScroll(scrollCustomer, { behavior, onScroll });
const { bottom } = toRefs(arrivedState);

const columns = ref<IColumn[]>([
  { field: "code", header: "カルテNo." },
  { field: "name", header: "名前" },
]);

const page = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const onSetCustomerIdRightSidebar = inject<AnyFn>("onSetCustomerIdRightSidebar");
const onLoadCustomerRightSidebar = inject<Fn>("onLoadCustomerRightSidebar");
const onSetHasLinkCustomer = inject<AnyFn>("onSetHasLinkCustomer");

const setClinicId = async () => set(clinicId, await inject("clinicId"));

const clinicIdParams = async () => ({ clinic_id: get(await get(clinicId)) });

const customerParams = async () => ({
  ...(await clinicIdParams()),
  term: get(term),
  rows: get(page) == 0 ? CUSTOMER_FIRST_PAGINATOR_ROWS : get(rows),
  page: get(page),
  filter_line_by: CustomerFilterLineBy.unlinked,
  filter_by: BasicCustomerFilterFields,
});

const loadCustomers = async () => {
  const { data } = (await CustomerServices.getCustomers(
    await customerParams(),
    () => undefined,
    () => undefined
  )) as unknown as AxiosResponse<ApiCustomerIndexRes>;
  const {
    customers: customersData,
    meta: { total_count, current_page },
  } = get(data);
  set(totalCount, total_count);
  if (customersData.length > 0) {
    customersData.forEach((customer: ICustomer) => {
      const index = get(useArrayFindIndex(customers, msg => msg.id == customer.id));
      if (index < 0) {
        customers.value.push(customer);
      }
    });
    get(customers).length == total_count ? disableLoadMore() : set(page, get(page) == 0 ? 2 : current_page);
  }
};

const onSearching = async () => {
  set(page, 0);
  set(customers, []);
  await loadCustomers();
};

const onItemClick = (event: any, customer: ICustomer) => {
  const setCustomerId = get(onSetCustomerIdRightSidebar) || ((id: number): void => undefined);
  const loadCustomer = get(onLoadCustomerRightSidebar) || ((): void => undefined);
  const setHasLinkedCustomer = get(onSetHasLinkCustomer) || ((hasLinked: boolean): void => undefined);
  setCustomerId(customer?.id || 0);
  loadCustomer();
  setHasLinkedCustomer(true);
};

onBeforeMount(async () => {
  await setClinicId();
  loadCustomers();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputText, {
            modelValue: term.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((term).value = $event)),
            class: "form-search-input",
            placeholder: "カルテNo.、お名前"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_Button, {
          class: "p-button-light ml-2",
          label: "検索",
          onClick: onSearching
        })
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", {
      ref_key: "scrollCustomer",
      ref: scrollCustomer,
      class: "customer-list-content overflow-auto"
    }, [
      _createVNode(Grid, {
        items: customers.value,
        columns: columns.value,
        onOnItemClick: onItemClick
      }, null, 8, ["items", "columns"])
    ], 512)
  ]))
}
}

})